module.exports = __webpack_public_path__ + "static/media/hilda_still.99da1434.jpg";